<template><div><h1>VUX V2.1.1Rc.11 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[enhance] 更加流畅的遮罩层动画</li>
</ul>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[enhance] 作为插件使用时，每次都重置属性值</li>
</ul>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] 修复插件代码里的值和事件监听器</li>
<li>[fix] 以插件方式显示时强制重置数据</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 支持格式化显示 prop:display-format #1086 @greedying</li>
</ul>
<h2><a href="/zh-CN/components/loading.html">Loading</a></h2>
<ul><li>[enhance] 以插件形式使用时强制重置属性值</li>
<li>[enhance] 添加渐现动画</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] 修复 Safari 下遮罩层渲染慢的问题 #1083 @sixiakun</li>
<li>[enhance] 默认开启 transfer-dom，解决非 Safari 也会出现的 z-index 问题</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修复遮罩禁用点击时错误设置 overflowScrolling 的问题</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[enhance] 更流畅的遮罩动画和弹窗动画</li>
<li>[enhance] 添加 dom 转移到 body 下的 demo</li>
<li>[enhance] 移除无用代码</li>
</ul>
<h2><a href="/zh-CN/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] 支持 on-focus on-blur 事件 #1082 @zeusLeeJh</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.11 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.11-206.vue?1d817c2c